document.addEventListener('DOMContentLoaded', function() {
  // Obtiene la URL actual
  const currentUrl = window.location.href;

  // Comprueba si la URL contiene "/it" o "/pt"
  if (currentUrl.includes('/it') || currentUrl.includes('/pt')) {
    // Selecciona el elemento que quieres ocultar
    const popupElement = document.querySelector('[data-testid="POPUP"]');

    // Si el elemento existe, lo oculta
    if (popupElement) {
      popupElement.style.display = 'none';
    }
  }
});
